import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  adjustGiftCardBalanceAddValue,
  giftCard,
  giftCards,
  createGiftCard,
  giftCardTransactions,
  giftCardEvents,
  giftCardBalanceReportResponse,
  giftCardImports,
  baseGiftCardImport,
} from './fixtures/giftcard-service.fixture';
import { getGiftCards, getLocationFields } from './fixture/gift-cards.fixture';
import { makeListResults } from 'test-util/api/response';
import { v4 as uuidv4 } from 'uuid';

export const sendGiftCardTransactionReceipt = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/giftcard/transaction/:giftcardTxtId/sendreceipt`,
    fn,
  );

export const createCompCardMock = fn =>
  rest.post(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-giftcard-service/card`,
    fn,
  );

export const listGiftCardsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/cards/search`,
    fn,
  );

export const getGiftCardMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/view`,
    fn,
  );

export const adjustGiftCardBalanceMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/admin-add-value`,
    fn,
  );

export const setZeroGiftCardBalanceMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/reset-balance`,
    fn,
  );

export const removeValueGiftCardBalanceMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/remove-value`,
    fn,
  );

export const activateGiftCardMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/activate`,
    fn,
  );

export const deactivateGiftCardMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/deactivate`,
    fn,
  );

export const resendEmailGiftCardMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/resendemail`,
    fn,
  );

export const getIntegrationMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/client/:clientId/giftcard/client-config`,
    fn,
  );

export const getLocationFieldMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/giftcard/locations-config`,
    fn,
  );

export const updateGiftCardConfigMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/giftcard/client-config/update`,
    fn,
  );

export const updateLocationConfigMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/giftcard/location-config/update`,
    fn,
  );

export const getGiftCardTransactionsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/transactions/view`,
    fn,
  );

export const getGiftCardEventsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/card/events/view`,
    fn,
  );

export const exportGiftCardBalanceReportCSVMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/clients/:clientId/balance-report/export`,
    fn,
  );

export const listGiftCardImportsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/cards/batch-summary`,
    fn,
  );

export const getGiftCardImportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/cards/batch-summary/:id`,
    fn,
  );

export const deleteGiftCardImportMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/cards/import/:id/remove`,
    fn,
  );

export const uploadGiftCardImportMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-giftcard-service/cards/import`,
    fn,
  );

export const handlers = () => [
  sendGiftCardTransactionReceipt((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  listGiftCardsMock((_req, res, ctx) => {
    return res(ctx.json(giftCards));
  }),
  getGiftCardMock((_req, res, ctx) => {
    return res(ctx.json(giftCard));
  }),
  adjustGiftCardBalanceMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  setZeroGiftCardBalanceMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  removeValueGiftCardBalanceMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  activateGiftCardMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  deactivateGiftCardMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  resendEmailGiftCardMock((_req, res, ctx) => {
    return res(ctx.json(adjustGiftCardBalanceAddValue));
  }),
  createCompCardMock((_req, res, ctx) => {
    return res(ctx.json(createGiftCard));
  }),

  getIntegrationMock((_req, res, ctx) => {
    return res(ctx.json(getGiftCards));
  }),

  getLocationFieldMock((_req, res, ctx) => {
    return res(ctx.json(getLocationFields));
  }),

  updateGiftCardConfigMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  updateLocationConfigMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  getGiftCardTransactionsMock((_req, res, ctx) => {
    return res(ctx.json(giftCardTransactions));
  }),

  getGiftCardEventsMock((_req, res, ctx) => {
    return res(ctx.json(giftCardEvents));
  }),

  exportGiftCardBalanceReportCSVMock((_req, res, ctx) =>
    res(ctx.json(giftCardBalanceReportResponse)),
  ),

  listGiftCardImportsMock((req, res, ctx) => {
    const enhancedImports = Object.values(giftCardImports).map(importItem => {
      return {
        ...importItem,
        parentBatch: importItem.parentBatchId
          ? giftCardImports[importItem.parentBatchId]
          : undefined,
        childBatches: importItem.childBatchIds
          ? importItem.childBatchIds.map(id => giftCardImports[id])
          : undefined,
      };
    });

    return res(
      ctx.json(
        makeListResults(enhancedImports, req.url.searchParams, {
          listName: 'content',
        }),
      ),
    );
  }),

  getGiftCardImportMock((req, res, ctx) => {
    const enhancedImport = {
      ...giftCardImports[req.params.id],
      parentBatch: giftCardImports[req.params.id]?.parentBatchId
        ? giftCardImports[giftCardImports[req.params.id]?.parentBatchId]
        : undefined,
      childBatches: giftCardImports[req.params.id]?.childBatchIds
        ? giftCardImports[req.params.id]?.childBatchIds.map(
            id => giftCardImports[id],
          )
        : undefined,
    };
    return res(ctx.json(enhancedImport));
  }),

  deleteGiftCardImportMock((req, res, ctx) => {
    const { id } = req.params;
    const uuid = uuidv4();
    giftCardImports[uuid] = {
      ...baseGiftCardImport,
      id: uuid,
      createdDate: new Date().toISOString(),
      parentBatchId: id,
      parentBatch: giftCardImports[id],
      status: 'SUCCESS',
      type: 'REMOVE_CARD',
    };
    giftCardImports[id].childBatchIds = [
      ...(giftCardImports[id].childBatchIds || []),
      uuid,
    ];
    giftCardImports[id].closed = true;
    return res(ctx.status(200));
  }),

  uploadGiftCardImportMock((req, res, ctx) => {
    const uuid = uuidv4();
    giftCardImports[uuid] = {
      ...baseGiftCardImport,
      id: uuid,
      status: 'IN_PROGRESS',
      createdDate: new Date().toISOString(),
      type: 'IMPORT_CARD',
    };
    return res(ctx.status(200));
  }),
];
